export const pricingData = [
  {
    name: "Starter",
    features: [
      { name: "1 User", included: true },
      { name: "2 Global Templates", included: true },
      { name: "5 Experiences / Month", included: true },
      { name: "Functions: All in Premium + View Recommendations", included: false },
      { name: "Sources: Manual Sources", included: true },
      { name: "Destinations", included: false },
      { name: "Create Own Templates", included: false },
      { name: "Bulk Functionality", included: false },
      { name: "Email Support", included: true },
    ],
    buttonText: "Upgrade Plan",
  },
  {
    name: "Professional",
    price: 19,
    features: [
      { name: "Up to 2 Users", included: true },
      { name: "All Global Templates", included: true },
      { name: "50 Experiences / Month", included: true },
      { name: "Functions: AT View Activities, AT Download Activities", included: true },
      { name: "Sources: Manual Sources", included: true },
      { name: "Destinations: Adobe Target", included: true },
      { name: "Create Own Templates", included: false },
      { name: "Bulk Functionality", included: true },
      { name: "Email Support", included: true },
    ],
    buttonText: "Upgrade Plan",
  },
  {
    name: "Plus",
    features: [
      { name: "Up to 10 Users", included: true },
      { name: "All Global Templates", included: true },
      { name: "Unlimited Experiences / Month", included: true },
      {
        name: "Functions: All in Professional + Adobe View Users, Tealium AudienceStream to Adobe Target Audiences",
        included: true,
      },
      { name: "Sources: Manual Sources, Adobe Target", included: true },
      { name: "Destinations: Adobe Target", included: true },
      { name: "Create Own Templates", included: true },
      { name: "Bulk Functionality", included: true },
      { name: "Email + Phone Support", included: true },
      { name: "20 AI Credits to generate content", included: true },
    ],
    buttonText: "Upgrade Plan",
  },
  {
    name: "Premium",
    features: [
      { name: "Up to 10 Users", included: true },
      { name: "All Global Templates", included: true },
      { name: "Unlimited Experiences / Month", included: true },
      {
        name: "Functions: All in Professional + Adobe View Users, Tealium AudienceStream to Adobe Target Audiences",
        included: true,
      },
      { name: "Sources: Manual Sources, Adobe Target", included: true },
      { name: "Destinations: Adobe Target", included: true },
      { name: "Create Own Templates", included: true },
      { name: "Bulk Functionality", included: true },
      { name: "Email + Phone Support", included: true },
      { name: "20 AI Credits to generate content", included: false },
    ],
    buttonText: "Upgrade Plan",
  },
  {
    name: "Enterprise",
    features: [
      { name: "Custom Pricing", included: true },
      { name: "Unlimited Users", included: true },
      { name: "All Global Templates", included: true },
      { name: "Unlimited Experiences / Month", included: true },
      { name: "Functions: All in Premium + View Recommendations", included: true },
      { name: "Sources: All", included: true },
      { name: "Destinations: All", included: true },
      { name: "Create Own Templates", included: true },
      { name: "Bulk Functionality", included: true },
      { name: "Email + Phone Support", included: true },
      { name: "Developer Support", included: true },
      { name: "Dedicated CSM", included: true },
    ],
    buttonText: "Book a Demo",
  },
]